import BricksOnSaleSummaryError from './BricksOnSaleSummaryError';
class OnSalePropertyIsNotRegistered extends BricksOnSaleSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('On sale property not registered', options);
        this.propertyId = propertyId;
    }
}
export default OnSalePropertyIsNotRegistered;
